var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorreo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1-correo {\r\n        fill: #ffcf04;\r\n      }\r\n\r\n      .cls-1-correo, .cls-2-correo {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2-correo {\r\n        fill: currentColor;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1390",
    "data-name": "Trazado 1390",
    className: "cls-2-correo",
    d: "M82.6,17.44H27.95c-12.76.01-23.11,10.36-23.12,23.12v42.04c0,5.8,4.71,10.5,10.51,10.51h79.88c5.8,0,10.5-4.71,10.51-10.51v-42.04c-.02-12.76-10.36-23.11-23.12-23.12M46.87,82.6c0,3.48-2.83,6.3-6.31,6.31H15.34c-3.48,0-6.3-2.83-6.31-6.31v-42.04c.08-10.45,8.62-18.85,19.07-18.77,10.33.08,18.69,8.44,18.77,18.77v42.04ZM101.52,82.6c0,3.48-2.83,6.3-6.31,6.31h-46.25c1.37-1.82,2.11-4.03,2.11-6.31v-42.04c0-7.53-3.67-14.59-9.84-18.91h41.37c10.44.01,18.9,8.47,18.92,18.91v42.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1391",
    "data-name": "Trazado 1391",
    className: "cls-1-correo",
    d: "M88.91,48.97v8.41c0,1.16-.94,2.1-2.1,2.1s-2.1-.94-2.1-2.1v-6.31h-18.92c-1.16,0-2.11-.93-2.11-2.09,0-1.16.93-2.11,2.09-2.11h21.04c1.16,0,2.1.94,2.1,2.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1392",
    "data-name": "Trazado 1392",
    className: "cls-1-correo",
    d: "M38.46,48.97c0,1.16-.94,2.1-2.1,2.1h-16.82c-1.16,0-2.11-.93-2.11-2.09s.93-2.11,2.09-2.11h16.83c1.16,0,2.1.94,2.1,2.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/correo.a0985225ebc32b182423d2b610721e98.svg";
export { ForwardRef as ReactComponent };